/**
 * Query keys for the contacts table, which renders both unscoped and scoped to
 * a single entity.
 */
export const contactKeys = {
  all: ["contacts"],
  lists: () => [...contactKeys.all, "list"],
  list: ({ entityId = null } = {}) => [...contactKeys.lists(), { entityId }],
};
